import React, { useEffect } from 'react'

import { useHistory } from 'react-router-dom'

import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'

/* Atoms */
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

/* Molecules */
import Breadcrumbs from 'components_new/molecules/Breadcrumbs'
import ErrorPlaceholder from 'components_new/molecules/ErrorPlaceholder'

/* Organisms */
import DashboardExample from 'components_new/organisms/DashboardExample'

/* Templates */
import PageLayout from 'components_new/templates/PageLayout'

/* Actions */
import { useDashboardExampleActions } from 'redux/actions/DashboardExamples'

/* Hooks */
import {
  useDashboardExample,
  useDashboardExamplesFetchStatus
} from 'redux/hooks/DashboardExamples'

const TemplatePage = () => {
  const params = useParams<{ id: string }>()
  const example = useDashboardExample(params.id)
  const { tryGetAllDashboardExamples } = useDashboardExampleActions()
  const fetchStatus = useDashboardExamplesFetchStatus()
  const history = useHistory()
  const { lang, t } = useTranslation()

  useEffect(() => {
    if (fetchStatus === 'idle') {
      tryGetAllDashboardExamples()
    }
  }, [])

  // Loading
  if (!example && (fetchStatus === 'idle' || fetchStatus === 'fetching')) {
    return null
  }

  // Error
  if (!example) {
    return (
      <PageLayout
        topbar={{
          title: (
            <Breadcrumbs
              items={[
                {
                  href: '/dashboards',
                  icon: { name: 'Dashboards' },
                  title: t('global', 'dashboards')
                },
                {
                  href: '/templates',
                  icon: { name: 'Templates' },
                  title: t('global', 'templates')
                }
              ]}
            />
          )
        }}
        variant="static"
      >
        <ErrorPlaceholder
          code={404}
          body={t('dashboards', 'error_not_found_body')}
          actions={
            <Button
              onClick={() => history.push('/templates')}
              startIcon={<Icon name="ArrowBackOutlined" />}
              variant="text"
            >
              {t('global', 'templates')}
            </Button>
          }
        />
      </PageLayout>
    )
  }

  return (
    <PageLayout
      content={{ size: 'large' }}
      topbar={{
        title: (
          <Breadcrumbs
            items={[
              {
                href: '/templates',
                icon: { name: 'Templates' },
                title: t('global', 'templates')
              },
              {
                href: `/templates/${params.id}`, // @TODO!
                title: example?.title[lang]
              }
            ]}
          />
        )
      }}
      variant="feed"
    >
      <DashboardExample />
    </PageLayout>
  )
}

export default TemplatePage
